import { createAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';

export interface MinMax {
    minimized?: boolean;
}

export const minMax = createAction<ActionType, MinMax>(
    ActionType.COACHING__CA__MIN_MAX,
);
